const Delete = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 10 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.55172 9.7828C8.52402 10.196 8.18075 10.5171 7.76659 10.5171H2.8022C2.38807 10.5171 2.04481 10.1961 2.01708 9.78286L1.57129 3.14038H8.99697L8.55172 9.7828Z"
        fill="#AEB9E1"
        stroke="#AEB9E1"
        strokeWidth="0.786884"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.565918 3.14111H10.0085"
        stroke="#AEB9E1"
        strokeWidth="0.944261"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.48937 1.42822H4.082C3.86917 1.42822 3.66506 1.5184 3.51458 1.67893C3.36409 1.83945 3.27954 2.05716 3.27954 2.28418V3.14013H7.29183V2.28418C7.29183 2.05716 7.20728 1.83945 7.05679 1.67893C6.9063 1.5184 6.70219 1.42822 6.48937 1.42822Z"
        stroke="#AEB9E1"
        strokeWidth="0.944261"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Delete;
